<template>
  <div>
    <div
      :class="['vault-row py-4', { 'has-divider': index > 0 }]"
      v-for="(dataItem, index) in vaultItems"
      :key="dataItem.type + dataItem.token"
    >
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6"
      >
        <span class="gray--text">Vault</span>
        <span>{{ dataItem.identity }}</span>
      </div>
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6 mt-2"
      >
        <span class="gray--text">Vault Balance</span>
        <span> ${{ dataItem.vaultBalance | numberFormat("0,0") }}</span>
      </div>
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6 mt-2"
      >
        <span class="gray--text">Strategy Balance</span>
        <span> ${{ dataItem.strategyBalance | numberFormat("0,0") }}</span>
      </div>
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6 mt-2"
      >
        <span class="gray--text">Total Value Locked</span>
        <span> ${{ dataItem.totalValueLocked | numberFormat("0,0") }}</span>
      </div>
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6 mt-2"
      >
        <span class="gray--text">3-Days Avg Yield</span>
        <span>
          <v-tooltip bottom color="dark" min-width="170">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="text-decoration-dotted"
                >{{ dataItem.yield3Days.apy | numberFormat("0,0.00", false) }}%
                APY</span
              >
            </template>
            <div class="text-6">
              <div class="d-flex justify-space-between">
                <div class="opacity-7">Fees ROI</div>
                <div>
                  {{
                    dataItem.yield3Days.feesROI | numberFormat("0,0.00", false)
                  }}%
                </div>
              </div>
              <div class="d-flex justify-space-between">
                <div class="opacity-7">Harvest ROI</div>
                <div>
                  {{
                    dataItem.yield3Days.harvestROI
                      | numberFormat("0,0.00", false)
                  }}%
                </div>
              </div>
              <v-divider
                style="border-color: white"
                class="mt-2 mb-2"
              ></v-divider>
              <div class="d-flex justify-space-between">
                <span class="opacity-7">{{
                  dataItem.yield3Days.bonus >= 0 ? "Slippage" : "Bonus"
                }}</span>
                <span>
                  <span v-if="dataItem.yield3Days.bonus"
                    >{{
                      dataItem.yield3Days.bonus
                        | abs
                        | numberFormat("0,0.000000")
                    }}%</span
                  >
                  <span v-else>-</span>
                </span>
              </div>
            </div>
          </v-tooltip>
        </span>
      </div>
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6 mt-2"
      >
        <span class="gray--text">15-Days Avg Yield</span>
        <span>
          <v-tooltip bottom color="dark" min-width="170">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="text-decoration-dotted"
                >{{ dataItem.yield15Days.apy | numberFormat("0,0.00", false) }}%
                APY</span
              >
            </template>
            <div class="text-6">
              <div class="d-flex justify-space-between">
                <div class="opacity-7">Fees ROI</div>
                <div>
                  {{
                    dataItem.yield15Days.feesROI
                      | numberFormat("0,0.00", false)
                  }}%
                </div>
              </div>
              <div class="d-flex justify-space-between">
                <div class="opacity-7">Harvest ROI</div>
                <div>
                  {{
                    dataItem.yield15Days.harvestROI
                      | numberFormat("0,0.00", false)
                  }}%
                </div>
              </div>
              <v-divider
                style="border-color: white"
                class="mt-2 mb-2"
              ></v-divider>
              <div class="d-flex justify-space-between">
                <span class="opacity-7">{{
                  dataItem.yield15Days.bonus >= 0 ? "Slippage" : "Bonus"
                }}</span>
                <span>
                  <span v-if="dataItem.yield15Days.bonus"
                    >{{
                      dataItem.yield15Days.bonus
                        | abs
                        | numberFormat("0,0.000000")
                    }}%</span
                  >
                  <span v-else>-</span>
                </span>
              </div>
            </div>
          </v-tooltip>
        </span>
      </div>
      <div
        class="d-flex align-center justify-space-between font-weight-medium text-6 mt-2"
      >
        <span class="gray--text">Ecosystem</span>
        <div class="d-flex align-center">
          <span>{{ dataItem.market.name }}</span>
          <img
            class="ml-2"
            :src="dataItem.market.logo"
            height="16"
            width="16"
            :alt="dataItem.market.name"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    vaultItems: Array,
  },
};
</script>

<style lang="scss" scoped>
.vault-row {
  &.has-divider {
    border-top: 1px solid #e3f9ed;
  }
}
</style>
